<template>
    
  <div class="d-flex flex-column vh-100">
    <b-navbar toggleable="lg">
      <img class="logo ml-4" :src="logoURL" alt="logo da prefeitura" border="0" />
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <h3 class="mr-3">|</h3>
      <router-link :to="homePath" class="navbar-brand d-none d-sm-inline-block">
        <h4>
          {{ sigla }}
        </h4>
      </router-link>
      <div class="ml-auto" v-if="ambiente === 'dev' || ambiente === 'hml'">
           <h4> 
              <b>
                 ( Homologação )
              </b>
           </h4>   
      </div>  
    </b-navbar>

    <div id="balao-container">
      <div id="balao">
        <div id="balao-image-container">
          <img :src="iconeAlerta" alt="Ícone de alerta">
        </div>
        <h4>COMUNICADO</h4>
        <h3>IMPORTANTE</h3>
        <div id="sistema-suspenso-conteudo">
          <p v-html="mensagem"></p>
        </div>
      </div>
    </div>

    <rodape class="mt-auto" :logoURL="logoURL" :versao="versao"></rodape>
  </div>
</template>

<script>
export default {
  props: ['titulo', 'mensagem'],

  data() {
    return {
      iconeAlerta: '/icons/icone-alerta.webp',
      mensagens: [],
      logoURL: process.env.VUE_APP_BASE_URL + "imgs/logomarcaPBH.jpeg",
    };
  },

  computed: {
    sigla() {
      return process.env.MIX_APP_SIGLA || process.env.VUE_APP_SIGLA;
    },

    ambiente() {
      return window.envJson.environment;
    },

    homePath() {
      return "/";
    },

    versao() {
      return process.env.MIX_APP_VERSAO || process.env.VUE_APP_VERSAO;
    },
  },
};
</script>

<style scoped>
.conteudo {
  max-width: 100%;
  min-width: 100%;
  padding-bottom: 15px;
  padding-top: 15px;
  display: flex;
  flex-direction: column;
}

.logo {
  max-width: 165px;
}

.navbar {
  background-color: #ffffff !important;
}

.nav-link {
  display: block;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 400;
  /* padding: 0.5rem 1rem; */
}
#balao-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
}
#balao-container #balao {
  border: 4px solid #326496;
  border-radius: 15px;
  padding: 30px;
  width: 700px;
  height: auto;
  text-align: center;
  background-color: #fff;
}
#balao-container #balao h3 {
  color: #326496;
  margin-bottom: 0;
  font-size: 30px;
  font-weight: 600;
}
#balao-container #balao h4 {
  color: #326496;
  margin-bottom: 0;
  font-size: 25px;
}
#balao-container #balao img {
  width: 100px;
  height: 100px;
  object-fit: contain;

}
#balao-container #balao p {
  margin: 15px 0;
  font-size: 20px;
}
#balao-container #balao-image-container {
  width: 100px;
  height: 100px;
  margin: auto;
}
</style>